export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
export const Users = () => import("./Users.vue");
export const CompUsersAdd = () => import("./CompUsersAdd.vue");
export const ParadeState = () => import("./ParadeState.vue");
export const ParadeUsers = () => import("./ParadeUsers.vue");
